import type { ContactAreaType } from '@models/api/contact-area-type.types';
import { AreaType } from '@models/api/contact-area-type.types';
import { ContactPersonBoxContactAreaType } from '@common/ContactPersonBoxContactAreaType/ContactPersonBoxContactAreaType';
import { ContactPersonBoxDistrictAreaType } from '@common/ContactPersonBoxDistrictAreaType/ContactPersonBoxDistrictAreaType';
import { ContactPersonBoxPostCodeAreaType } from '@common/ContactPersonBoxPostCodeAreaType/ContactPersonBoxPostCodeAreaType';

export interface ContactPersonBoxProps {
  visible: boolean;
  contactAreaType: ContactAreaType | null;
}
export const ContactPersonBox = ({ visible, contactAreaType }: ContactPersonBoxProps) => {
  switch (contactAreaType?.areaType) {
    case AreaType.POSTCODE:
    case AreaType.NONE:
      return <div>{visible && <ContactPersonBoxPostCodeAreaType />}</div>;
    case AreaType.DISTRICT:
      return (
        <div>
          {visible && (
            <ContactPersonBoxDistrictAreaType
              districts={contactAreaType?.districts ? contactAreaType?.districts : []}
            />
          )}
        </div>
      );
    case AreaType.CONTACTS:
      return (
        <div>
          {visible && (
            <ContactPersonBoxContactAreaType contacts={contactAreaType?.contacts ? contactAreaType?.contacts : []} />
          )}
        </div>
      );
    default:
      return null;
  }
};
